import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=b1c70acc&scoped=true&"
import script from "./LinkWidget.vue?vue&type=script&lang=js&"
export * from "./LinkWidget.vue?vue&type=script&lang=js&"
import style0 from "./LinkWidget.vue?vue&type=style&index=0&id=b1c70acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c70acc",
  null
  
)

export default component.exports